import type { IFrameComponent, IFrameMessageData, IFrameOptions } from 'iframe-resizer'
import { iframeResizer } from 'iframe-resizer'

const DEFAULT_OPTIONS = <IFrameOptions>{
    log: false,
    heightCalculationMethod: 'max',
    onMessage: (e: IFrameMessageData) => {
        if (e.message === 'Open popup') setTimeout(() => e.iframe.scrollIntoView(), 1500)
    }
}

export const vIframeResize = {
    beforeMount(el: HTMLElement, { value = { ...DEFAULT_OPTIONS } }) {
        el.addEventListener('load', () => iframeResizer(value, el))
    },
    unmounted(el: IFrameComponent) {
        // @ts-ignore
        el.iFrameResizer.removeListeners()
    }
}
